import React, { Component } from 'react';
import { Button, Flex, Text } from 'core/components';
import { InputGroup } from 'core/form';
import styled from 'styled-components';
import { observer } from 'mobx-react';

const BoardTitleInput = styled(InputGroup)`
  &.bp3-input-group input {
    font-size: 14px;
    height: 28px;
  }
`;

@observer
class BoardTitle extends Component {
  state = {
    editing: false,
    title: ''
  };

  componentDidMount() {
    const { board } = this.props;
    this.setState({ title: board.get('title') });
  }

  handleHeaderClick = () => {
    const { board } = this.props;
    this.setState({ title: board.get('title'), editing: true });
  };

  handleInputChange = (event) => {
    this.setState({ title: event.target.value });
  };

  handleInputKeyPress = (event) => {
    const { board } = this.props;
    if (event.key === 'Enter') {
      this.handleInputBlur();
    } else if (event.key === 'Escape') {
      this.setState({ editing: false, title: board.get('title') });
    }
  };

  handleInputBlur = () => {
    const { board, onSave } = this.props;
    const { title } = this.state;

    this.setState({ editing: false });

    if (title !== board.get('title')) {
      onSave({ title });
    }
  };

  render() {
    const { board, canEdit } = this.props;
    const { editing, title } = this.state;

    if (!canEdit) {
      return <Text>{board.get('title')}</Text>;
    }

    return (
      <Flex alignItems="center" minWidth="fit-content">
        {editing ? (
          <BoardTitleInput
            autoFocus
            value={title}
            onChange={this.handleInputChange}
            onKeyDown={this.handleInputKeyPress}
            onBlur={this.handleInputBlur}
            placeholder="Title..."
            fill
          />
        ) : (
          <Button minimal textAlign="left" onClick={this.handleHeaderClick} mx={-1} style={{ cursor: 'text' }}>
            {board.get('title')}
          </Button>
        )}
      </Flex>
    );
  }
}

export default BoardTitle;
